import { PanelRow, ToggleControl, Button, TextControl, Notice, IconButton } from '@wordpress/components'
import { dispatch } from '@wordpress/data'

import { __ } from '@wordpress/i18n'

export default ({ allData, price, priceIndex }) => {
    const { has_group_price, group_prices } = price
    const { updateTripPricing } = dispatch('WPTravel/TripEdit');

    let groupPricesData = 'undefined' != typeof group_prices ? group_prices : [] 
    let addGroupPrice = () => {
        let priceData = price;

        priceData.group_prices = [...groupPricesData, {
            min_pax: '',
            max_pax: '',
            price: ''
        }];
        updateTripPricing(priceData, priceIndex)
    }
    return <>
        <PanelRow>
            <label>{__('Enable Group Price', 'wp-travel-pro')}</label>
            <div className="text-right">
                <ToggleControl
                    checked={has_group_price}
                    onChange={() => {
                        let priceData = price;
                        priceData.has_group_price = !priceData.has_group_price
                        updateTripPricing(priceData, priceIndex)
                    }}
                />
                <p className="description"><i>This will enable group discount for pricing.</i></p>
            </div>
        </PanelRow>

        { has_group_price && <>
            <PanelRow className="wp-travel-has-child-panel">
                <label>{__('Group Prices', 'wp-travel-pro')}</label>
            </PanelRow>
            <PanelRow className="wp-travel-has-child-panel">
                { 'undefined' !== typeof group_prices && group_prices.length > 0 ?
                    <table className="wp-list-table widefat striped ">
                        <thead>
                            <tr>
                                <td>{__('Min Pax', 'wp-travel-pro')}</td>
                                <td>{__('Max Pax', 'wp-travel-pro')}</td>
                                <td>{__('Price', 'wp-travel-pro')}</td>
                                <td></td>
                            </tr>
                        </thead>
                        <tbody>
                            {group_prices.length > 0 ? group_prices.map((groupPrice, groupPriceIndex) => <tr>
                                <td><TextControl
                                    type="number"
                                    min={"0" == groupPriceIndex ? 1 : parseInt( group_prices[groupPriceIndex-1].max_pax ) +1 }
                                    max={ 'undefined' != typeof price.max_pax &&  price.max_pax > 0 ? price.max_pax : null}
                                    autoComplete="off"
                                    value={groupPrice.min_pax} 
                                    onChange={(min_pax) => {
                                        let priceData = price;
                                        priceData.group_prices[groupPriceIndex].min_pax = min_pax
                                        updateTripPricing(priceData, priceIndex);
                                    }} /></td>
                                <td><TextControl
                                    type="number"
                                    min={groupPrice.min_pax ? parseInt( groupPrice.min_pax ) : 0}
                                    max={ 'undefined' != typeof price.max_pax ? price.max_pax : null}
                                    autoComplete="off"
                                    value={groupPrice.max_pax} onChange={(max_pax) => {
                                        let priceData = price;
                                        priceData.group_prices[groupPriceIndex].max_pax = max_pax
                                        updateTripPricing(priceData, priceIndex);
                                    }} /></td>
                                <td><TextControl type="number" step="0.01" value={groupPrice.price} onChange={(gprice) => {
                                    let priceData = price;
                                    priceData.group_prices[groupPriceIndex].price = gprice
                                    updateTripPricing(priceData, priceIndex);
                                }} /></td>
                                <td><IconButton
                                    icon="trash"
                                    label="Delete"
                                    onClick={() => {
                                        if (!confirm(__('Are you sure to delete group price?', 'wp-travel-pro'))) {
                                            return false;
                                        }
                                        let priceData = price;
                                        priceData.group_prices = group_prices.filter((groupPriceFilter, groupPriceFilterIndex) => {
                                            return groupPriceIndex != groupPriceFilterIndex;
                                        });
                                        updateTripPricing(priceData, priceIndex)
                                    }}
                                /></td>
                            </tr>) : <tr><td colSpan="4">{__('No Group Price.', 'wp-travel-pro')}</td></tr>}

                        </tbody>
                    </table> : <Notice isDismissible={false} actions={[{
                        'label': 'Add Group Price',
                        onClick: () => {
                            addGroupPrice()
                        },
                        noDefaultClasses: true,
                        className: 'is-link'
                    }]}>{__('No Group Price found.', 'wp-travel-pro')}</Notice>}
            </PanelRow>

            { 'undefined' !== typeof group_prices && group_prices.length > 0 &&
                <PanelRow className="wp-travel-action-section has-right-padding">
                    <span></span>
                    <Button isDefault onClick={() => addGroupPrice()}>{__('+ Add Group Price', 'wp-travel-pro')}</Button>
                </PanelRow>} </>}
    </>
}